module.exports = __webpack_public_path__ + "graphql_playground.06699dee.mp4";